import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
// Component
import Box from './Box';
import Text from './Text';
// Icons
import Lock16 from '../../icons/Lock16';

const LogoContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

const StyledCard = styled.img`
  height: 28px;
  width: auto;
  max-width: 45px;
  object-fit: contain;
`;

const StyledStripe = styled.img`
  height: 28px;
  width: auto;
  max-width: 82px;
  object-fit: contain;
`;

const StyledWallet = styled.img`
  height: 28px;
  width: auto;
  max-width: 60px;
  object-fit: contain;
`;

const CardLogos = ({ ...props }) => {
  const { t } = useTranslation();
  return (
    <>
      <LogoContainer
        {...props}
        role="img"
        aria-label="Moyens de paiement acceptés"
        mt={3}>
        <StyledStripe src="/static/img/logos/stripe.png" alt="Stripe" />
        <StyledCard src="/static/img/logos/Visa.png" alt="Visa" />
        <StyledCard src="/static/img/logos/Mastercard.png" alt="Mastercard" />
        <StyledCard src="/static/img/logos/CB.png" alt="Carte Bancaire" />
        <StyledWallet
          src="https://upload.wikimedia.org/wikipedia/commons/b/b0/Apple_Pay_logo.svg"
          alt="Apple Pay"
        />
        <StyledWallet
          src="https://upload.wikimedia.org/wikipedia/commons/f/f2/Google_Pay_Logo.svg"
          alt="Google Pay"
        />
      </LogoContainer>
      <Box flexDirection="column" mb={4} mt={2}>
        <Box flexDirection="row" alignItems="center" mb={1}>
          <Lock16 aria-hidden="true" />
          <Text
            variant="caption"
            ml={1}
            style={{
              fontFamily: 'LTSaeada, Arial, sans-serif',
              color: '#2e414b',
              fontSize: '0.85rem',
            }}>
            {t('cardlogo.text')}
          </Text>
        </Box>
        <Text
          style={{
            fontFamily: 'LTSaeada, Arial, sans-serif',
            color: 'rgba(46, 65, 75, 0.6)',
            fontSize: '0.8rem',
            lineHeight: 1.4,
          }}>
          Vos détails de paiement sont stockés en toute sécurité par notre
          partenaire Stripe.
        </Text>
      </Box>
    </>
  );
};

export default CardLogos;
